import React from 'react';

import { Skeleton } from 'antd';

import { Input } from './_input';
import { Paragraph } from './_paragraph';
import { Value } from './_value';

export const Placeholder = ({
  children,
  loading,
  ...other
}: React.ComponentProps<typeof Skeleton> & {
  children: React.ReactNode;
}) => (
  <Skeleton loading={loading} active={true} {...other}>
    {!loading && children}
  </Skeleton>
);

Placeholder.Input = Input;
Placeholder.Value = Value;
Placeholder.Paragraph = Paragraph;
